/*@ngInject*/
const OptionGroupButtonController = function ($rootScope, $scope, $state, $timeout, $element, $uibModal, localization, configurationConstant) {

    $element.addClass('optionGroupButton');

    var timeoutList = [];

    localization.getTranslationByKey('optionGroupButton').then(function (translations) {

        this.step1ItemName = '';
        this.step2ItemName = '';

        this.init = function () {
            var valueArray,
                delimiter;

            this.defaultMode = 'forms';

            if (!_.isNil(this.selectedField.fieldTemplate.linkFormTemplateUniqueName) && !_.isNil(this.selectedField.fieldTemplate.linkVariableName)) {
                this.fieldPropertyModel = 'forms';
            } else if (!_.isNil(this.selectedField.fieldTemplate.linkPropertyPath)) {
                this.fieldPropertyModel = 'objects';
            } else {
                this.fieldPropertyModel = this.defaultMode;
            }

            if (this.name === 'linkTo') {
                if (!_.isNil(this.buttonLinkText)) {
                    if (this.fieldPropertyModel === 'forms') {
                        delimiter = '::';
                    } else {
                        delimiter = '.';
                    }

                    valueArray = _.split(this.buttonLinkText, delimiter);
                    this.step1ItemName = valueArray[0];
                    this.step2ItemName = valueArray[1];
                }
            }

            this.buildButtonLinkText();
        };

        this.$onChanges = function () {
            this.buildButtonLinkText();
        };

        this.buildButtonLinkText = function () {
            if (this.buttonLinkText) {
                if (this.buttonLinkText.length > 25) {
                    this.linkText = this.buttonLinkText.substring(0, 25) + '...';
                    this.tooltip = this.buttonLinkText;
                } else {
                    this.linkText = this.buttonLinkText;
                    this.tooltip = '';
                }
            } else {
                this.linkText = this.defaultButtonLinkText;
                this.tooltip = '';
            }
        };

        this.click = function () {
            if (this.defaultButtonLinkText === 'Edit Expression') {
                $uibModal.open({
                    templateUrl: '/configuration/javaScriptExpression/javaScriptExpressionTemplate.tpl.html',
                    controller: 'javaScriptExpressionController',
                    windowClass: 'javaScriptExpressionModal',
                    backdrop: 'static',
                    keyboard: false,
                    resolve: {
                        fieldTemplate: function () {
                            return this.selectedField.fieldTemplate;
                        }.bind(this),
                        expressionName: function () {
                            return this.name;
                        }.bind(this),
                        expressionValue: function () {
                            var propertyName = this.name;
                            // special case that setting name is different from property name
                            if ('disableExpressions' === propertyName) {
                                propertyName = 'propertyExpression';
                            }
                            return this.selectedField.fieldTemplate[propertyName];
                        }.bind(this)
                    }
                });
            }
            else if (this.defaultButtonLinkText === 'Edit Regular Expression') {
                $uibModal.open({
                    templateUrl: '/configuration/regularExpression/regularExpressionTemplate.tpl.html',
                    controller: 'regularExpressionController',
                    windowClass: 'regularExpressionModal',
                    backdrop: 'static',
                    keyboard: false,
                    resolve: {
                        fieldTemplate: function () {
                            return this.selectedField.fieldTemplate;
                        }.bind(this),
                        propertyName: function () {
                            return this.name;
                        }.bind(this),
                        propertyValue: function () {
                            var value = null;
                            if (this.buttonLinkText !== 'Edit Regular Expression') {
                                value = this.buttonLinkText;
                            }
                            return value;
                        }.bind(this)
                    }
                });
            }
            else if (this.defaultButtonLinkText === 'Edit Rule') {
                $state.go('configuration.formEditor.rules', {ruleName: this.selectedField.fieldTemplate.triggerRuleName});
            }
        };

        if (this.name === 'linkTo') {
            timeoutList.push($timeout(function () {
                $scope.$on(configurationConstant.event.SELECTOR_WIDGET_UPDATED, function (event, item1Name, item2) {
                    var value = null;

                    if (this.fieldPropertyModel === 'forms' && !_.isNil(item1Name) && !_.isNil(item2.fieldName)) {
                        value = item1Name + '::' + item2.fieldName;
                    } else if (!_.isNil(item1Name) && !_.isNil(item2.propertyName)) {
                        value = item1Name + '.' + item2.propertyName;
                    }

                    $rootScope.$broadcast(configurationConstant.event.OPTION_GROUP_INPUT_VALUE_CHANGED, {
                        name: this.name,
                        value: value
                    });
                }.bind(this));
            }.bind(this), 0));
        }

        $scope.$on('$destroy', function () {
            _.each(timeoutList, function (item) {
                $timeout.cancel(item);
            });
        });

        this.init();
    }.bind(this));
};

angular.module('ums.configuration')
    .controller('optionGroupButtonController', OptionGroupButtonController);
